import type { IChartApi } from "lightweight-charts";
import { Timeframes } from "@/components/widgets/Chart/types";
import { ONE_DAY_IN_S, ONE_YEAR_IN_S } from "@/lib/utils";
import type { PriceInfo } from "../../services/PriceService/PriceService";

type ScrollOptions = {
	chart: IChartApi;
	result: PriceInfo[];
	timeFrame: Timeframes;
};

export function setFullVisibleLogicalRange({
	chart,
	result,
	timeFrame,
}: ScrollOptions) {
	if (
		!chart ||
		!result.length ||
		(timeFrame !== Timeframes.FIVE_MIN && timeFrame !== Timeframes.ONE_DAY)
	)
		return;

	const toIndex = result.length - 1;
	const toTime = result[toIndex].time;

	let targetPastTimestamp: number;

	if (timeFrame === Timeframes.FIVE_MIN) {
		targetPastTimestamp = toTime - ONE_DAY_IN_S;
	} else if (timeFrame === Timeframes.ONE_DAY) {
		targetPastTimestamp = toTime - ONE_YEAR_IN_S;
	}

	const fromIndex = result.findLastIndex(
		(c) => c.time <= targetPastTimestamp && c.time <= toTime,
	);

	chart.timeScale().setVisibleLogicalRange({
		from: fromIndex === -1 ? 0 : fromIndex,
		to: toIndex,
	});
}
